"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgBackspaceOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.backspace_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "backspace_outline_svg__transparent_box" },
            React.createElement("path", { className: "backspace_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "backspace_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "backspace_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M7.48 5l-7.7 11 7.7 11H32V5zM30 25H8.52l-6.3-9 6.3-9H30z" }),
            React.createElement("path", { d: "M14.22 21.19l3.54-3.53 3.53 3.53 1.42-1.41-3.54-3.54 3.54-3.53-1.42-1.42-3.53 3.54-3.54-3.54-1.41 1.42 3.53 3.53-3.53 3.54 1.41 1.41z" }))));
}
exports.default = SvgBackspaceOutline;
//# sourceMappingURL=BackspaceOutline.js.map